<!-- @veltra/icons generated sha256:e03d1e0168600bd6 gen:8 source:src/svg/normal/arrow-up.svg -->
<script setup lang="ts">
defineOptions({ name: 'ArrowUp' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="m11.996 10.004-.01.01a.63.63 0 0 1-.903-.011L8 6.92l-3.083 3.083a.65.65 0 0 1-.92-.006l-.01-.01a.63.63 0 0 1 .012-.905l3.649-3.649a.497.497 0 0 1 .704 0l3.649 3.65a.653.653 0 0 1-.005.92"
    />
  </svg>
</template>
